import * as React from "react";
import css from "./HowItWorks.module.css";

const steps = [
  {
    title: "Order Items",
    text: "Choose any product to get signed by your favorite actors, characters, and influencers.",
  },
  {
    title: "Watch It Personalized",
    text: "Watch your item get personally signed by your favorite Talent on camera.",
  },
  {
    title: "Leave It To Streamily",
    text: "The Talent will send your orders to Streamily and we'll make sure it's processed and safely sent to you!",
  },
  {
    title: "Yours Forever",
    text: "Have a one-of-a-kind personalized autograph from your favorite Talent to hold onto forever.",
  },
];

export default function HowItWorks() {
  return (
    <div className={css.wrapper}>
      <section className={css.section}>
        <h2 className={css.heading}>How Streamily Works</h2>

        <div className={css.grid}>
          {steps.map(({ title, text }, i) => (
            <div className={css.card} key={title}>
              <p className={css.stepNumber}>{i + 1}</p>
              <h3 className={css.stepTitle}>{title}</h3>
              <p className={css.stepText}>{text}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
